import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

export const DivContainer = styled.div`
  padding: 8px;
  background-color: ${COLOR.GRAY100.code};
  overflow: auto;
  max-height: calc(100vh - ${GLOBAL_NAVI_HEIGHT.PC}px);
  max-height: calc(var(--1dvh, 1vh) * 100 - ${GLOBAL_NAVI_HEIGHT.PC}px);
  max-height: calc(100dvh - ${GLOBAL_NAVI_HEIGHT.PC}px);

  ${mq.sp} {
    max-height: calc(100vh - ${GLOBAL_NAVI_HEIGHT.SP}px);
    max-height: calc(var(--1dvh, 1vh) * 100 - ${GLOBAL_NAVI_HEIGHT.SP}px);
    max-height: calc(100dvh - ${GLOBAL_NAVI_HEIGHT.SP}px);
  }
`;

export const ImgDesktopPremiumBanner = styled.img`
  border-radius: 12px;
  padding: 8px;
  width: 184px;
  height: 68px;
`;

export const ImgMobilePremiumBanner = styled.img`
  border-radius: 12px;
  padding: 8px;
  width: 100%;
  max-width: 390px;
`;
